<template>
  <div>
    <story-viewer v-if="false" :show.sync="showStoryViewer" :stories="storyUsers" :start-index="storyStartIndex" />

    <v-container class="pa-0">
      <v-row justify="center">
        <v-col cols="12" md="8" lg="6">
          <story-reel v-if="false" :users="storyUsers" @view-story="onViewStory" class="mb-5" />

          <div class="ptr-container" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
            <div class="ptr-indicator">
              <div :style="indicatorStyle">
                <v-progress-circular v-if="pullDown.isRefreshing" indeterminate color="primary" size="28"></v-progress-circular>
                <v-icon color="white" v-else :style="arrowStyle">mdi-arrow-down</v-icon>
              </div>
            </div>

            <div class="feed-content" :class="{ 'is-transitioning': !pullDown.isDragging }" :style="contentStyle">
              <div v-if="loading && feedItems.length === 0" class="text-center py-16">
                <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
              </div>

              <div v-else-if="feedItems && feedItems.length > 0">
                <feed-item-card
                  @view-profile="showUserProfile"
                  @delete-post="confirmDeletePost"
                  v-for="item in feedItems"
                  :key="item._id"
                  :item="item"
                  class="mb-6"
                  @post-updated="$emit('post-updated')" />
              </div>

              <div v-else class="text-center white--text py-16">
                <v-icon color="white" size="80" class="mb-4">mdi-newspaper-variant-outline</v-icon>
                <h3 class="text-h6">Dein Feed ist noch leer</h3>
                <p class="body-1 mt-2">Finde Freunde, um ihre Aktivitäten hier zu sehen!</p>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FeedItemCard from "./FeedItemCard.vue"
import StoryReel from "./StoryReel.vue"
import StoryViewer from "./StoryViewer.vue"
import api from "@/api"

// Konstanten für die Animation
const PULL_THRESHOLD = 100 // Nötige Distanz zum Auslösen (in px)
const PULL_RESISTANCE = 0.65 // Widerstand (macht das Ziehen "schwerer")
const REFRESH_POSITION = 50 // Position des Ladeindikators beim Laden

export default {
  components: {
    FeedItemCard,
    StoryReel,
    StoryViewer,
  },
  props: {
    feedItems: { type: Array, required: true },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    // Bestehende Daten
    showStoryViewer: false,
    storyStartIndex: 0,
    storyUsers: [
      // ... deine Story-Beispieldaten ...
    ],
    // NEU: Daten für Pull-to-Refresh
    pullDown: {
      startY: 0,
      pullDistance: 0,
      isDragging: false,
      isRefreshing: false,
    },
  }),

  computed: {
    contentStyle() {
      const yPos = this.pullDown.isRefreshing ? REFRESH_POSITION : this.pullDown.pullDistance
      return {
        transform: `translateY(${yPos}px)`,
      }
    },
    indicatorStyle() {
      const opacity = Math.min(this.pullDown.pullDistance / (PULL_THRESHOLD / 1.2), 1)
      return {
        opacity: this.pullDown.isRefreshing ? 1 : opacity,
      }
    },
    arrowStyle() {
      const rotation = this.pullDown.pullDistance >= PULL_THRESHOLD ? 180 : 0
      return {
        transform: `rotate(${rotation}deg)`,
        transition: "transform 0.2s ease",
      }
    },
  },

  watch: {
    // Beobachtet das 'loading'-Prop von der Eltern-Komponente
    loading(isLoading) {
      if (!isLoading && this.pullDown.isRefreshing) {
        // Wenn das Laden beendet ist, setze alles zurück
        this.pullDown.isRefreshing = false
        this.pullDown.pullDistance = 0
      }
    },
  },

  methods: {
    // --- NEU: Pull-to-Refresh Methoden (mit Bugfix für Scrolling) ---
    handleTouchStart(e) {
      // WICHTIG: Nur starten, wenn nicht schon geladen wird UND man GANZ oben auf der Seite ist.
      // Das verhindert den Scroll-Bug.
      if (this.loading || window.scrollY !== 0) return
      if (!e.touches[0]) return
      this.pullDown.isDragging = true
      this.pullDown.startY = e.touches[0].clientY
    },

    handleTouchMove(e) {
      if (!this.pullDown.isDragging) return
      if (!e.touches[0]) return
      const currentY = e.touches[0].clientY
      const diffY = currentY - this.pullDown.startY

      // Nur nach unten ziehen, nicht nach oben
      if (diffY > 0) {
        // Verhindert das Standard-Browser-Scrollen, während wir unsere Animation zeigen
        e.preventDefault()
        this.pullDown.pullDistance = diffY * PULL_RESISTANCE
      }
    },

    handleTouchEnd() {
      if (!this.pullDown.isDragging) return
      this.pullDown.isDragging = false

      if (this.pullDown.pullDistance >= PULL_THRESHOLD) {
        this.pullDown.isRefreshing = true
        this.$emit("refresh-feed") // Eltern-Komponente signalisieren
      } else {
        // Nicht weit genug gezogen -> sanft zurückgleiten lassen
        this.pullDown.pullDistance = 0
      }
      this.pullDown.startY = 0 // Immer zurücksetzen
    },

    // --- DEINE BESTEHENDEN METHODEN (unverändert) ---
    confirmDeletePost(postId) {
      if (window.confirm("Bist du sicher, dass du diesen Post endgültig löschen möchtest?")) {
        this.handleDeletePost(postId)
      }
    },
    async handleDeletePost(postId) {
      try {
        await api.social.deletePost(postId)
        this.$emit("post-updated")
      } catch (error) {
        console.log(error)
        alert("Post konnte nicht gelöscht werden.")
      }
    },
    showUserProfile(userId) {
      this.$emit("view-profile", userId)
    },
    onViewStory(userId) {
      const index = this.storyUsers.findIndex((u) => u.id === userId)
      if (index > -1) {
        this.storyStartIndex = index
        this.showStoryViewer = true
      }
    },
  },
}
</script>

<style scoped>
/* Der Hauptcontainer, der die Touch-Events empfängt */
.ptr-container {
  position: relative;
}

/* Der Wrapper für deinen Feed-Inhalt */
.feed-content.is-transitioning {
  /* Aktiviert die sanfte Animation NUR, wenn der Nutzer NICHT zieht */
  transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Positioniert den Lade-Indikator oben in der Mitte */
.ptr-indicator {
  position: absolute;
  top: 15px; /* Etwas Abstand vom oberen Rand */
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;

  pointer-events: none;
}
</style>
